const heroContent2 = {
  Adobesection:{
    titlePart1: "Adobe XD Course",
    // titlePart2: "Stem Courses",
    description: "Polymath-Kids offers an exciting Adobe XD course for kids in Grade 4 and above, teaching them to create stories, posters, slides, animations, and more. Students will learn UI/UX and graphic design fundamentals while developing creativity, problem-solving, and branding skills. The course helps kids build professional-level designs and real-world skills.",
    buttonText: "Book a free demo lesson",
  },
    Corelsection:{
    titlePart1: "Corel Draw Course",
    // titlePart2: "Stem Courses",
    description: "CorelDRAW is a Vector graphic software, allowing the user to produce outstanding Illustrations with millions of colours. To help kids deliver their message creatively and develop aesthetic sense, Polymath-Kids offers a Graphic Design with CorelDRAW course for kids age 9 and above. Kids will learn to pay attention to details, develop organizational and observational skills and create meaningful and impeccable designs.",
    buttonText: "Book a free demo lesson",
    },
    photoshopsection:{
    titlePart1: "Photoshop Course",
    // titlePart2: "Stem Courses",
    description: "Polymath-Kids offers a comprehensive Photoshop course for kids aged 12 and above, teaching powerful photo editing and graphic design skills. Students will develop artistic abilities, enhance creativity, and learn to create flawless designs while mastering one of the most in-demand design tools.",
     buttonText: "Book a free demo lesson",
    },
    canvasection:{
    titlePart1: "Canva for Beginners Course",
    // titlePart2: "Stem Courses",
    description: "This fun and engaging course introduces young students to graphic design and UI/UX using the easy-to-use Canva platform. Kids will learn to create stories, posters, slides, and more while developing creativity, design thinking, and real-world skills in branding and problem-solving.",
    buttonText: "Book a free demo lesson",
  },
    illustratorsection:{
    titlePart1: "Adobe Illustrator Course",
    // titlePart2: "Stem Courses",
    description: "Polymath-Kids offers an Adobe Illustrator course where kids learn graphic design fundamentals through live online classes. Students will master basic and advanced Illustrator tools, creating custom drawings, logos, business cards, and more, while developing creativity, artistry, and problem-solving skills.",
    buttonText: "Book a free demo lesson",
  },
  modelsection:{
    titlePart1: "3D Modeling with Tinkercad",
    // titlePart2: "Stem Courses",
    description: "Discover the exciting world of 3D design! Our course teaches kids how to create digital models using Tinkercad, from basic shapes to printable designs. Perfect for beginners, this course develops spatial reasoning and creative problem-solving skills through hands-on projects.",
    buttonText: "Book a free demo lesson",
  },
  figmasection:{
    titlePart1: "UI/UX Design with Figma",
    // titlePart2: "Stem Courses",
    description: "Discover the exciting world of digital design! Our Figma course teaches kids the fundamentals of UI/UX design, from creating simple icons to designing complete apps and websites. Perfect for creative minds, this course develops visual design and prototyping skills through hands-on projects.",
    buttonText: "Book a free demo lesson",
  }
}
export default heroContent2;